export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/retro.dfe40c1.svg";